/**
 * A CHAVE de um logradouro (21/10/2026 — taxa de entrega por rua): o nome da rua sem acento, sem caixa, sem pontuação,
 * sem o tipo de via no começo ("Rua", "R.", "Avenida", "Av." …), com os títulos abreviados ("Doutor" → "dr") e sem
 * "de/da/do/dos/das/e". O que vem depois da primeira vírgula é cortado (o número digitado junto da rua).
 *
 * <p>É a MESMA regra do servidor (backend ChaveLogradouro.java), testada contra os mesmos casos
 * (docs/fixtures/logradouro/chaves.json): o checkout casa a rua digitada com a rua cadastrada exatamente como o
 * servidor fará ao receber o pedido.
 */
const TIPOS_DE_VIA = new Set([
  'rua', 'r', 'avenida', 'av', 'avda', 'travessa', 'tv', 'trav', 'alameda', 'al', 'estrada', 'estr', 'est',
  'rodovia', 'rod', 'praca', 'pca', 'pc', 'largo', 'lgo', 'viela', 'passagem', 'psg', 'servidao',
]);

const TITULOS: Record<string, string> = {
  doutor: 'dr',
  doutora: 'dra',
  professor: 'prof',
  professora: 'profa',
  vereador: 'ver',
  vereadora: 'vera',
  engenheiro: 'eng',
  padre: 'pe',
  coronel: 'cel',
  capitao: 'cap',
  general: 'gen',
  senador: 'sen',
  deputado: 'dep',
  presidente: 'pres',
  governador: 'gov',
  prefeito: 'pref',
  monsenhor: 'mons',
  sargento: 'sgt',
  tenente: 'ten',
  comendador: 'com',
};

const LIGACOES = new Set(['de', 'da', 'do', 'das', 'dos', 'e']);

export function chaveLogradouro(logradouro: string | null | undefined): string {
  if (logradouro == null) return '';
  let s = logradouro;
  const virgula = s.indexOf(',');
  if (virgula >= 0) s = s.slice(0, virgula);
  s = s
    .normalize('NFD')
    .replace(/\p{M}+/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  if (!s) return '';
  const palavras = s.split(' ');
  while (palavras.length > 1 && TIPOS_DE_VIA.has(palavras[0])) palavras.shift();
  return palavras
    .filter((p) => !LIGACOES.has(p))
    .map((p) => TITULOS[p] ?? p)
    .join(' ');
}
